import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RxService } from 'src/app/Services/NewVisitNote/rx.service';
import { IMedicationMasterData } from 'src/app/models/IMedicationMasterData';
@Component({
  selector: 'app-search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.css']
})
export class SearchBoxComponent implements OnInit {
  type: any;
  errorallergenmsgtxt: string = '';
  selectedMedication: IMedicationMasterData;
  constructor(public rxService: RxService,
    public dialogRef: MatDialogRef<SearchBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    this.type = data.inputType;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  ngOnInit() {
  }

  allergiesSearchList: IMedicationMasterData[] = [];
  getAllergiesbySearch(searchstr: string, type: any) {
    this.rxService.getAllergyMedicationsWithCodes(searchstr, this.type).subscribe(data => {
      this.allergiesSearchList = data;
      if(data.length == 0 || data == null)
      this.errorallergenmsgtxt = 'No Records Found';
      else
      this.errorallergenmsgtxt = '';
    });
  }
  white: string = 'opacity: 0.0';
  blue: string = '#BAFBC1';
  selectedRowIndex: number = -1;
  selectionChangedList(index: number, item: any) {
    this.selectedRowIndex=item.medicationMasterName
    this.selectedMedication = item;
     this.data.inputValue = item.medicationMasterName;
    // for (var i = 0; i < this.tempallergiesSearchList.length; i++) {
    //   this.tempallergiesSearchList[i].background = this.white;
    // }
    // const symindex = this.tempallergiesSearchList.findIndex(x => x.medicationMasterName === item.medicationMasterName);
    // this.tempallergiesSearchList[symindex].background = this.blue;
  }

  onAdd() {
    this.dialogRef.close(this.selectedMedication);
  }

}
export interface DialogData {
  inputValue: string;
  headerText: string;
  inputType: string;
}
